import { globalStyle, style } from '../layer.css.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, fonts, fontWeight, space } from '../tokens';
import { typography } from '../typography';

export const streamCardV2 = style({
  position: 'relative',
  justifyContent: 'space-between',
  minHeight: 177,
  height: '100%',
});

export const streamCardV2Main = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  width: '100%',
  minWidth: 0,
});

export const streamCardV2Tags = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  minWidth: 0,
  flexWrap: 'wrap',
});

export const streamCardV2Body = style({
  gap: space.s4,
});

export const streamCardV2Title = style({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const streamCardV2Description = style({
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const streamCardV2Targets = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  width: '100%',
  minWidth: 0,
  padding: space.s12,
  backgroundColor: themeV2.color.bg.surface.secondary,
  boxShadow: hairline(themeV2.color.border.subtle),
  borderRadius: borderRadius.r16,
});

export const streamCardV2TargetsLabel = style({
  margin: 0,
  fontFamily: fonts.mono,
  fontWeight: fontWeight.medium,
  fontSize: 12,
  lineHeight: 1.3,
  letterSpacing: '-0.04em',
  color: themeV2.color.text.quaternary,
});

export const streamCardV2TargetsChips = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: space.s4,
  width: '100%',
  minWidth: 0,
});

export const streamCardV2TargetsMore = style({
  ...typography.labelSm,
  color: themeV2.color.text.quaternary,
  letterSpacing: '-0.04em',
  whiteSpace: 'nowrap',
  flexShrink: 0,
});

export const streamCardV2TargetChip = style({
  ...typography.labelSm,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: space.s4,
  minHeight: 24,
  padding: `${space.s4}px ${space.s8}px`,
  borderRadius: borderRadius.r8,
  boxShadow: hairline(themeV2.color.border.subtle),
  color: themeV2.color.text.quaternary,
  letterSpacing: '-0.04em',
  whiteSpace: 'nowrap',
  flexShrink: 0,
});

globalStyle(`.${streamCardV2TargetChip} :where(svg)`, {
  width: 12,
  height: 12,
  flexShrink: 0,
});

export const streamCardV2Meta = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: space.s12,
  flexShrink: 0,
});

export const streamCardV2View = style({
  ...typography.labelMd,
  display: 'inline-flex',
  alignItems: 'center',
  gap: space.s8,
  color: themeV2.color.text.secondary,
});

globalStyle(`.${streamCardV2View} :where(svg)`, {
  width: 16,
  height: 16,
  flexShrink: 0,
});
